import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import ReactSwipe from 'react-swipe';
import theme from 'ui/styles/theme';
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'

export default class JpnCategories extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount = () => {
    }



    render() {
        const { bgcolor, category_button } = this.props

        const { } = this.state




        return (
            <Wrapper bgcolor={bgcolor}>
                <InnerWrapper fluid categoryAmount={category_button.length === 3 ? 3 : 2}>
                    {category_button.map((item, index) =>
                        <ButtonWrapper key={index}>
                            <ButtonLink to={getRelativeUrl(item.url.link)}>
                                <Overlay>
                                    <Image src={item.image.sourceUrl} alt={item.title}></Image>
                                </Overlay>
                                <Title>{item.title}<Arrow /></Title>
                                <Subtitle>{item.subtitle}</Subtitle>
                            </ButtonLink>
                        </ButtonWrapper>
                    )}
                </InnerWrapper>
            </Wrapper>
        )
    }
}


const breatheAnimation = keyframes`
0% {
    opacity: 0;
    transform: translateX(-0.8rem);
}

50% {
    opacity: 1;
    transform: translate(0);
}

100% {
    opacity: 0;
    transform: translate(0);
}
`

const Arrow = styled.span`
    content:''; /* Required to display content */
    display: inline-block;
    margin-left: 28px; /* Set margin equal to border px */
    width: 0;
    z-index:11;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 15px solid green;
    animation-name: ${breatheAnimation};
    animation-duration: 4s;
    animation-iteration-count: infinite;
    opacity: 1
`
const ButtonLink = styled(Link)`
text-decoration: none;
color: white;
`


const TitleContainer = styled.div`
`



const InnerWrapper = styled(Container)`
padding: 0 20px;
margin-bottom: 20px;
display: flex;
flex-wrap: wrap;
width: 100%;

${media.lg`
padding: 0 20%;
margin-top: 30px;
justify-content: ${props => props.categoryAmount === 3 ? "space-between" : "space-evenly"};
`}
`
const Overlay = styled.div`
&&::before {
    content: '';
    z-index: 10;
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    background: linear-gradient(rgba(0,64,119,0.8), rgba(2,0,36,0.9));
}
`

const Title = styled.h2`
position: absolute;
bottom: 20px;
left: 15px;
z-index: 11;
width: 100%;
`
const Subtitle = styled.h3`
font-size: 24px;
font-weight: 200;
position: absolute;
bottom: 5px;
left: 15px;
z-index: 11;
`
const ButtonWrapper = styled.div`
position: relative;
text-align: left;
color: white;
margin-bottom: 20px;
width: 100%;
${media.lg`
width: 33%;
`}

`

const Image = styled.img`
background: linear-gradient(rgba(2,0,36,0.9),  rgba(0,64,119,0.8));
background-repeat: no-repeat;
height: 54vw;
background-position: center;
background-color: white;
object-fit: cover;
width: 100%;

${media.lg`
height: 30vw;
background-color: initial;
`}

${media.xl`
height: 17vw;
`}
`

const Wrapper = styled.div`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
margin-top: 8%;

${media.lg`
margin-top: 0;
`}
`
const HeroWrapper = styled(Container)`
                    padding: 0 0px;
                    ${media.lg`
                    padding: 0 0%;
                    `}
                    `
const Heading = styled.h2`
font-size: 35px !important;
font-weight: 350 !important;
line-height: 1.2 !important;
margin-bottom: 0px !important;
`

const ProductName = styled.div`
${media.md`
margin-top: 5px;
`}

`




// WEBPACK FOOTER //
// ./src/ui/components/modules/JpnCategories/index.js